<template>
    <div class="width-66 width-sm-100 mx-auto">
        <vs-card>
            <div class="flex justify-center items-center" slot="header" >                
                <h4 style="text-transform: uppercase; ">{{inventObj.category_name}}</h4>
            </div>
            <!-- <div class="details-short-info my-2">
                <vs-row>
                    <vs-col class="my-1" vs-type="flex" vs-align="center" vs-w="6">
                        <feather-icon icon="MapPinIcon" />
                        <span>San Francisco United State</span>
                    </vs-col>
                    <vs-col class="my-1" vs-type="flex" vs-align="center" vs-w="6">
                        <feather-icon icon="MailIcon" />
                        <span>xyz@gmail.com</span>
                    </vs-col>
                    <vs-col class="my-1" vs-type="flex" vs-align="center" vs-w="6">
                        <feather-icon icon="GlobeIcon" />
                        <span>website.com</span>
                    </vs-col>
                    <vs-col class="my-1" vs-type="flex" vs-align="center" vs-w="6">
                        <feather-icon icon="PhoneIcon" />
                        <span>+0000000000</span>
                    </vs-col>
                </vs-row>
            </div> -->
            <div class="carousel-example">
                <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                    <swiper-slide v-for="(roomimage, index) in inventObj.asset_images" :key="index">
                        <img class="responsive" :src="roomimage.files_details.file_path" alt="banner">
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
                
            </div>
            <div class="mt-6 text-center"> 
                <h5 class="mb-4">Inventory Name: {{inventObj.name}}</h5> 
                <h5>Inventory Description: {{inventObj.asset_details}}</h5>
            </div>
        </vs-card>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'Rooms Details',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      inventObj: {}
    }
  },
  created () {
    this.inventObj = this.$route.params.inventoryDetail
  }
}
</script>

<style>
    .details-info svg {
        color: rgba(var(--vs-primary), 1);
        width: 16px;
        margin-right: 5px;
    }
    .amenities-list li {
        width: 50%;
        display: inline-flex;
        flex-wrap: wrap;
        margin: 10px 0;
        padding-left: 10px;
        position: relative;
        font-weight: 500;
    }
    .amenities-list li:before {
        content: '\00B7';
        color: rgba(var(--vs-primary), 1);
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 20px;
        font-weight: bold;
    }
    .swiper-slide img {
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 400px;
        object-fit: contain;
    }
</style>